const AVAILABILITY_PARAM = 'filter.v.availability';

function syncAvailability(params) {
  const hasOtherFilters = [...params.keys()].some((key) => key.startsWith('filter.') && key !== AVAILABILITY_PARAM);

  if (hasOtherFilters) {
    params.set(AVAILABILITY_PARAM, '1');
  } else {
    params.delete(AVAILABILITY_PARAM);
  }

  return params;
}

customElements.whenDefined('facets-form-component').then(() => {
  const FacetsForm = customElements.get('facets-form-component');
  const proto = FacetsForm?.prototype;

  if (!proto || proto.__3didsAvailability) return;
  proto.__3didsAvailability = true;

  const createURLParameters = proto.createURLParameters;
  proto.createURLParameters = function (...args) {
    return syncAvailability(createURLParameters.apply(this, args));
  };

  const updateFiltersByURL = proto.updateFiltersByURL;
  proto.updateFiltersByURL = function (url) {
    const nextUrl = new URL(url, window.location.origin);
    syncAvailability(nextUrl.searchParams);
    return updateFiltersByURL.call(this, nextUrl.pathname + nextUrl.search + nextUrl.hash);
  };
});
